"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownList = exports.DEFAULT_MOBILE_ITEM_HEIGHT = exports.DEFAULT_ITEM_HEIGHT = exports.LOADING_HEIGHT = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var Form_1 = require("../Form");
var DropdownTabs_1 = require("./DropdownTabs");
var List_1 = require("../List");
var LoadingMask_1 = require("../LoadingMask");
var NoData_1 = require("../NoData");
var AutoSize_1 = require("../AutoSize");
/**
 * @internal
 */
exports.LOADING_HEIGHT = 100;
/**
 * @internal
 */
exports.DEFAULT_ITEM_HEIGHT = 28;
/**
 * @internal
 */
exports.DEFAULT_MOBILE_ITEM_HEIGHT = 40;
var defaultNoData = react_intl_1.injectIntl(function (_a) {
    var hasNoMatchingData = _a.hasNoMatchingData, intl = _a.intl;
    return (react_1.default.createElement(NoData_1.NoData, { hasNoMatchingData: hasNoMatchingData, notFoundLabel: intl.formatMessage({ id: "gs.noData.noMatchingData" }), noDataLabel: intl.formatMessage({ id: "gs.noData.noDataAvailable" }) }));
});
/**
 * @internal
 */
function DropdownList(props) {
    var _a = props.className, className = _a === void 0 ? "" : _a, width = props.width, height = props.height, isMobile = props.isMobile, isLoading = props.isLoading, _b = props.items, items = _b === void 0 ? [] : _b, _c = props.itemsCount, itemsCount = _c === void 0 ? items.length : _c, _d = props.itemHeight, itemHeight = _d === void 0 ? exports.DEFAULT_ITEM_HEIGHT : _d, _e = props.mobileItemHeight, mobileItemHeight = _e === void 0 ? exports.DEFAULT_MOBILE_ITEM_HEIGHT : _e, showSearch = props.showSearch, disableAutofocus = props.disableAutofocus, searchString = props.searchString, searchPlaceholder = props.searchPlaceholder, searchFieldSize = props.searchFieldSize, onSearch = props.onSearch, showTabs = props.showTabs, tabs = props.tabs, selectedTabId = props.selectedTabId, onTabSelect = props.onTabSelect, _f = props.renderNoData, renderNoData = _f === void 0 ? defaultNoData : _f, scrollToSelected = props.scrollToSelected, listProps = tslib_1.__rest(props, ["className", "width", "height", "isMobile", "isLoading", "items", "itemsCount", "itemHeight", "mobileItemHeight", "showSearch", "disableAutofocus", "searchString", "searchPlaceholder", "searchFieldSize", "onSearch", "showTabs", "tabs", "selectedTabId", "onTabSelect", "renderNoData", "scrollToSelected"]);
    var hasNoData = !isLoading && itemsCount === 0;
    var hasNoMatchingData = hasNoData && !!searchString;
    var listClassNames = classnames_1.default("gd-infinite-list", className);
    var searchFieldClassNames = classnames_1.default("gd-list-searchfield", "gd-flex-item");
    var renderFooter = function () {
        var footer = props.footer, closeDropdown = props.closeDropdown;
        if (footer && closeDropdown && typeof footer === "function") {
            return footer(closeDropdown);
        }
        return footer || false;
    };
    var onChange = react_1.useCallback(function (search) { return onSearch(search.toString()); }, [onSearch]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        showSearch && (react_1.default.createElement(Form_1.Input, { className: searchFieldClassNames, value: searchString, onChange: onChange, isSmall: searchFieldSize === "small", placeholder: searchPlaceholder, clearOnEsc: true, isSearch: true, autofocus: !disableAutofocus })),
        showTabs && react_1.default.createElement(DropdownTabs_1.DropdownTabs, { tabs: tabs, selectedTabId: selectedTabId, onTabSelect: onTabSelect }),
        hasNoData && (react_1.default.createElement("div", { style: { width: isMobile ? "auto" : width } }, renderNoData({ hasNoMatchingData: hasNoMatchingData }))),
        isLoading && react_1.default.createElement(LoadingMask_1.LoadingMask, { width: isMobile ? "100%" : width, height: exports.LOADING_HEIGHT }),
        !isLoading && itemsCount > 0 && (react_1.default.createElement(AutoSize_1.AutoSize, null, function (autoSize) {
            var listWidth = isMobile ? autoSize.width : width;
            var listHeight = isMobile ? autoSize.height : height;
            return (react_1.default.createElement(List_1.List, tslib_1.__assign({ className: listClassNames, width: listWidth, height: listHeight, items: items, itemsCount: itemsCount, itemHeight: isMobile ? Math.max(mobileItemHeight, itemHeight) : itemHeight, scrollToSelected: scrollToSelected }, listProps)));
        })),
        renderFooter()));
}
exports.DropdownList = DropdownList;
//# sourceMappingURL=DropdownList.js.map